import { useMemo } from "react";

import { GenderEnum } from "../models";
import { CommitteeStatus } from "../models/Committee";
import {
  RequestType,
  RequestStatus,
  OutsideEnrollmentAreaStatus,
  LanguageCourseDecisionStatus,
  RegistrationFormStatus,
  InstitutionChangeReason,
} from "../models/Request";
import { SchoolCandidateStatus } from "../models/SchoolCandidate";
import { MsgUtils } from "../utils";

export const useEnumCodeBooks = () => {
  const { getEnumToCodeBook } = MsgUtils;

  const requestTypeCodeBook = useMemo(
    () => getEnumToCodeBook(RequestType, "requestType"),
    [getEnumToCodeBook]
  );

  const requestStatusCodeBook = useMemo(
    () => getEnumToCodeBook(RequestStatus, "requestStatus"),
    [getEnumToCodeBook]
  );

  const outsideEnrollmentAreaStatusCodeBook = useMemo(
    () =>
      getEnumToCodeBook(
        OutsideEnrollmentAreaStatus,
        "outsideEnrollmentAreaStatus"
      ),
    [getEnumToCodeBook]
  );

  const languageCourseDecisionStatusCodeBook = useMemo(
    () =>
      getEnumToCodeBook(
        LanguageCourseDecisionStatus,
        "languageCourseDecisionStatus"
      ),
    [getEnumToCodeBook]
  );

  const registrationFormStatusCodeBook = useMemo(
    () => getEnumToCodeBook(RegistrationFormStatus, "registrationFormStatus"),
    [getEnumToCodeBook]
  );

  const institutionChangeReasonCodeBook = useMemo(
    () => getEnumToCodeBook(InstitutionChangeReason, "institutionChangeReason"),
    [getEnumToCodeBook]
  );

  const schoolCandidateStatusCodeBook = useMemo(
    () => getEnumToCodeBook(SchoolCandidateStatus, "schoolCandidateStatus"),
    [getEnumToCodeBook]
  );

  const genderCodeBook = useMemo(
    () => getEnumToCodeBook(GenderEnum, "gender"),
    [getEnumToCodeBook]
  );

  const committeeStatusCodeBook = useMemo(
    () => getEnumToCodeBook(CommitteeStatus, "CommitteeStatus"),
    [getEnumToCodeBook]
  );

  return {
    requestTypeCodeBook,
    requestStatusCodeBook,
    outsideEnrollmentAreaStatusCodeBook,
    languageCourseDecisionStatusCodeBook,
    registrationFormStatusCodeBook,
    institutionChangeReasonCodeBook,
    schoolCandidateStatusCodeBook,
    genderCodeBook,
    committeeStatusCodeBook,
  };
};
